import React from "react"

import {
    AmenityCategory,
    type AmenityFieldsFragment,
} from "~graphql/generated/graphql"
import ListingAmenitiesListByCategory from "~components/pages/listing/listing-amenities/listing-amenities-list-by-category"
import COPY from "~config/copy-constants"

interface Props {
    readonly amenities: AmenityFieldsFragment[] | null | undefined
}

export default function ListingAmenities({ amenities }: Props) {
    if (!amenities?.length) return null

    const nonIncludedAmenities = amenities.filter(
        ({ category }) => category !== AmenityCategory.Include
    )
    const includedAmenities = amenities.filter(
        ({ category }) => category === AmenityCategory.Include
    )

    return (
        <>
            <ListingAmenitiesListByCategory
                title={COPY.AMENITIES}
                amenities={nonIncludedAmenities}
                shouldRenderDivider
            />
            <ListingAmenitiesListByCategory
                title={COPY.TRIP_INCLUDES}
                amenities={includedAmenities}
            />
        </>
    )
}
